import { render, staticRenderFns } from "./MonitoringDashboard.vue?vue&type=template&id=474fa85c&scoped=true&"
import script from "./MonitoringDashboard.vue?vue&type=script&lang=ts&"
export * from "./MonitoringDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./MonitoringDashboard.vue?vue&type=style&index=0&id=474fa85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474fa85c",
  null
  
)

export default component.exports